(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener("click", function(event) {
  const swatchLink = event.target.closest(".swatch-link");
  if (!swatchLink) return;

  event.preventDefault();

  const newImage = swatchLink.dataset.image;
  const newUrl = swatchLink.dataset.url;
  const card = swatchLink.closest(".card");

  if (!card) return;

  // Update main product image
  const mainImgs = card.querySelectorAll(".card__media img");
  if (newImage && mainImgs.length) {
    mainImgs.forEach(img => {
      img.src = newImage;
      img.srcset = newImage;
    });
  }

  // Update all relevant title links in this card
  const titleLinks = card.querySelectorAll(".card__heading a, a[id^='CardLink-'], a[id^='StandardCardNoMediaLink-']");
  if (newUrl && titleLinks.length) {
    titleLinks.forEach(link => {
      link.href = newUrl;
    });
  }

  // Remove active class from all swatches in this card
  const allSwatches = card.querySelectorAll(".swatch-link .swatch");
  allSwatches.forEach(s => s.classList.remove("active"));

  // Add active class to the clicked swatch
  const swatch = swatchLink.querySelector(".swatch");
  if (swatch) swatch.classList.add("active");
});
  } catch(e) { console.error(e); }
})();

})();
